import { render, staticRenderFns } from "./CreateSourceDrawer.vue?vue&type=template&id=1aa0a64d&scoped=true"
import script from "./CreateSourceDrawer.vue?vue&type=script&lang=js"
export * from "./CreateSourceDrawer.vue?vue&type=script&lang=js"
import style0 from "./CreateSourceDrawer.vue?vue&type=style&index=0&id=1aa0a64d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa0a64d",
  null
  
)

export default component.exports